import React from 'react'
import { localized, withDialogs } from 'decorators'
import { DialogsSwitch } from '.'

const DialogsContainer = ({ dialogs, localize, hideDialog }) => {
  return <DialogsSwitch dialogs={dialogs} localize={localize} hideDialog={hideDialog} />
}

export default withDialogs(localized(DialogsContainer))
